import { formatCurrency } from 'utils/numberUtilities'

export const PriceInCurrency = ({ price, currencyName, exchangeRate }) => {
  if (currencyName) {
    return `${formatCurrency({ value: price, code: currencyName })} (${formatCurrency({ value: price * exchangeRate })})`
  }
  return formatCurrency({ value: price })
}
